import * as Sentry from '@sentry/vue'

export function useMonitor() {
  function initReportLimitStorage() {
    if (!sessionStorage.getItem('sentry_report_limit')) {
      const reportLimit = {
        JS_EXIST_URI: []
      }
      sessionStorage.setItem('sentry_report_limit', JSON.stringify(reportLimit))
    }
    const reportLimit: any = sessionStorage.getItem('sentry_report_limit')
    return JSON.parse(reportLimit)
  }

  function initSentryConfig() {
    const dsn = 'https://762f67750a184996a77de515ae138b20@sentry.evkland.cn/3'
    const tracingOrigins: (string | RegExp)[] = [
      ...(process.env.VUE_APP_SENTRY_TRACING_ORIGINS || '')
        .split(',')
        .map((origin) => origin.trim())
        .filter(Boolean),
      /^\//
    ]
    const envMap: any = {
      development: 'development',
      stable: 'stable',
      stableMe: 'stable-me',
      stableSa: 'stable-sa',
      production: 'production',
      productionMe: 'production-me',
      productionSa: 'production-sa'
    }
    const env = envMap[process.env.VUE_APP_ENV || 'development']
    return {
      dsn,
      env,
      tracingOrigins
    }
  }

  function startMonitor({ app }: any) {
    const { dsn, env, tracingOrigins } = initSentryConfig()

    if (dsn && tracingOrigins?.length) {
      // 初始化Sentry监控
      Sentry.init({
        app,
        dsn, // 后续根据环境变量来变动
        integrations: [
          new Sentry.BrowserTracing({
            tracingOrigins
          })
        ],
        tracesSampleRate: 1.0,
        environment: env
      })

      // 添加全局unhandledrejection事件监听
      window.addEventListener('unhandledrejection', (event) => {
        Sentry.captureException({ sourceType: 'promise', message: event?.reason?.message || 'promise异步错误', stack: event?.reason?.stack || '', event })
      })
      // vue的全局错误监听
      app.config.errorHandler = (err: any) => {
        Sentry.captureException({ sourceType: 'vue', message: 'Vue全局监听检测到错误', event: err })
      }
      // window的error监听
      window.addEventListener('error', (event: any) => {
        // 限制同一个资源上报次数
        const reportLimit = initReportLimitStorage()
        const tagNameWhiteList = ['VIDEO', 'IMG', 'AUDIO', 'SOURCE', 'SCRIPT', 'STYLE', 'LINK']
        // 去除一些不需要上报的资源
        if (!tagNameWhiteList.includes(event?.target?.tagName)) {
          // JavaScript 运行时错误
          const errorMessage = event.message
          const errorInfo = {
            sourceType: event?.target?.tagName || 'js error',
            message: errorMessage,
            event
          }
          const isExist = reportLimit.JS_EXIST_URI.includes(errorMessage)

          // console.log('Error message:', event, isExist)
          // console.log('tagName', event?.target?.tagName)

          // 你可以在这里将错误信息发送到 Sentry 或其他错误监控服务
          if (!errorMessage || !isExist) {
            Sentry.captureException(errorInfo)
            if (errorMessage) {
              reportLimit.JS_EXIST_URI.push(errorMessage)
            }
          }
        }
        sessionStorage.setItem('sentry_report_limit', JSON.stringify(reportLimit))
      }, true)
    }
  }

  return {
    startMonitor
  }
}
